import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';
import { Button } from '@chakra-ui/react';

const Navbar = () => {

    const log_out = () =>{
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("userDetails");
        localStorage.removeItem("isSeller");
    }


    return (
        <nav className="nav">
            <Link to="/" className="site-title">Supplier Dashboard</Link>
            <ul>
                <li><NavLink to="/">Home</NavLink></li> 
                    <li><Link to="/login" onClick={() => log_out()}>Log Out</Link></li>
                    <li></li>                  
            </ul>
        </nav>
    );
}

export default Navbar;